import React, { useState, useEffect } from "react";
import { AppBar, Dialog, Slide, Toolbar, CircularProgress } from "@mui/material";
import SingleCustomAutocomplete from "src/Components/CustomAutocomplete/SingleCustomAutocomplete";
import { generateForm } from "src/helpers/functions";
import axios from "axios";
import { toast } from "react-toastify";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const PaymentAddUpdateForm = ({
  addUpdatePaymentVisible,
  handleClose,
  jobId,
  paymentId,
  paymentType
}) => {
  const [saveIsLoading, setSaveIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    job_id: jobId,
    amount: null,
    due_date: "",
    paid: false,
    type: paymentType,
    method: "",
    id: -1,
  });

  const resetForm = () => {
    setFormData({
      job_id: jobId,
      amount: null,
      due_date: "",
      paid: false,
      type: paymentType,
      method: "",
      id: -1,
    });
  };

  const customJobPaymentOnChange = (newValue, name) => {
    setFormData((prev) => ({
      ...prev,
      [name]: newValue,
    }));
  };

  const handleInputChange = (e) => {
    e.preventDefault();
    const { id, value, checked, type } = e.target;
    if (type === "checkbox") {
      setFormData({
        ...formData,
        [id]: checked,
      });
    } else {
      setFormData({
        ...formData,
        [id]: value,
      });
    }
  };

  const getData = () => {
    axios({
      method: "get",
      url: `${process.env.REACT_APP_API}/admin/jobs/payments/getById/${paymentId}`,
    })
      .then((response) => {
        setFormData({
          job_id: jobId,
          amount: response.data.amount,
          due_date: response.data.due_date,
          method: response.data.method,
          paid: response.data.paid == 1 ? true : false,
          type: response.data.type,
          id: response.data.id,
        });
      })
      .catch((error) => {
        toast.error(`Error`);
      });
  };

  const saveForm = () => {
    setSaveIsLoading(true);
    if (formData.id > 0) {
      const submitFormData = generateForm(formData);
      axios({
        method: "post",
        url: `${process.env.REACT_APP_API}/admin/jobs/updatePayment`,
        data: submitFormData,
      })
        .then((response) => {
          toast.success(`Updated successfully`);
          setSaveIsLoading(false);
          handleClose();
        })
        .catch((error) => {
          setSaveIsLoading(false);
          toast.error(`Error While Saving`);
        });
    } else {
      const submitFormData = generateForm(formData);
      axios({
        method: "post",
        accept: "any",
        url: `${process.env.REACT_APP_API}/admin/jobs/payments/add`,
        data: submitFormData,
      })
        .then((response) => {
          toast.success(`Inserted successfully`);
          setSaveIsLoading(false);
          handleClose();
        })
        .catch((error) => {
          setSaveIsLoading(false);
          toast.error(`Error While Saving`);
        });
    }
  };

  useEffect(() => {
    if (paymentId > 0) {
      if (addUpdatePaymentVisible) getData();
    } else {
      resetForm();
    }
  }, [addUpdatePaymentVisible, paymentId, jobId, paymentType]);

  return (
    <Dialog
      fullScreen
      open={addUpdatePaymentVisible}
      onClose={handleClose}
      TransitionComponent={Transition}
      style={{ zIndex: 2235 }}
    >
      <AppBar className="position-relative">
        <Toolbar>
          <button
            type="button"
            className="close-modal-button"
            onClick={handleClose}
          >
            &times;
          </button>
          <h4 className="text-white mx-3 my-0">
            {formData.id > 0 ? "Update" : "Add"}
          </h4>
        </Toolbar>
      </AppBar>
      <div style={{ padding: "25px" }}>
        <div className="row">
          <div className={"col-sm-6"}>
            <div className="form-group">
              <label htmlFor="name">Amount</label>
              <input
                type="text"
                className="form-control"
                id="amount"
                onChange={handleInputChange}
                value={formData.amount}
              />
            </div>
          </div>
          <div className={"col-sm-6"}>
            <div className="form-group">
              <div className="dateView">
                <label
                  style={{ fontSize: "18px", marginTop: "10px", marginRight: "10px" }}
                  htmlFor="due_date"
                >
                  Due Date
                </label>
                <input
                  type="date"
                  style={{ width: 200, height: 50, border: "1px solid #D3D3D3", borderRadius: 5 }}
                  id="due_date"
                  value={formData.due_date}
                  onChange={handleInputChange}
                />
              </div>
            </div>
          </div>
          <div className={"col-sm-6"}>
            <SingleCustomAutocomplete
              disabled={paymentType}
              filedName="type"
              label="Type"
              list={[
                { id: "in", name: "From Client" },
                { id: "out", name: "To worker" },
              ]}
              value={formData.type}
              listKey="id"
              description="name"
              customOnChange={customJobPaymentOnChange}
            />
          </div>
          <div style={{ padding: "25px" }}>
            <div className="row">
              <div className={"col-sm-6"}>
                <SingleCustomAutocomplete
                  filedName="method"
                  label="Method of Payment"
                  list={[
                    { id: 1, name: "Cash" },
                    { id: 2, name: "Whish" },
                    { id: 3, name: "OMT" },
                    { id: 4, name: "Bank Transfer" },
                  ]}
                  value={formData.method}
                  listKey="id"
                  description="name"
                  customOnChange={customJobPaymentOnChange}
                />
              </div>
              <div className={"col-sm-6"}>
                <div className="form-group" style={{ padding: "20px" }}>
                  <input
                    className="form-control-checkbox"
                    id="paid"
                    type="checkbox"
                    checked={formData.paid}
                    onChange={handleInputChange}
                  />
                  <label style={{ paddingLeft: 10 }} htmlFor="paid">
                    Paid
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className={"col-sm-12 mt-5"}>
            {saveIsLoading ? (
              <CircularProgress />
            ) : (
              <button
                className="btn btn-md btn-primary float-end"
                onClick={saveForm}
              >
                Save
              </button>
            )}
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default PaymentAddUpdateForm; 